<template>
  <div class="list fs-sm">
    <!-- {{ breadList }} -->
    <span class="router-name" @click="toHome">{{ routeHome }} </span
    >&nbsp;>&nbsp;
    <span class="router-name" v-show="routeOne != ''" @click="toPrePage('one')"
      >{{ routeOne }}
    </span>
    <span v-show="routeTwo != ''">&nbsp;>&nbsp;</span>
    <span
      class="router-name"
      v-show="routeTwo != ''"
      @click="toPrePage('two')"
      >{{ routeTwo }}</span
    >
    <span v-show="routeThree != ''">&nbsp;>&nbsp;</span>
    <span
      class="router-name"
      v-show="routeThree != ''"
      @click="toPrePage('three')"
      >{{ routeThree }}</span
    >
  </div>
</template>
<script>
export default {
  name: 'breadlist',
  props: ['routeQuery'],
  components: {},
  data() {
    return {
      routeHome: '首页',
      routeOne: '',
      routeTwo: '',
      routeThree: '',
      //   routeFour: '',
      path: '',
      keepalive: 0,
      keepchild: 0,
    }
  },
  created() {
    this.routeOne = this.routeQuery.one
    this.routeTwo = this.routeQuery.two
    this.routeThree = this.routeQuery.three
    this.keepalive = this.routeQuery.keepalive
  },
  watch: {
    $route: {
      handler(newVal) {
        this.routeOne = newVal.query.one
        this.routeTwo = newVal.query.two
        this.routeThree = newVal.query.three
        this.keepalive = newVal.query.keepalive
        this.routeQuery.path1 = newVal.query.path1
        this.routeQuery.path2 = newVal.query.path2
      },
      deep: true,
    },
  },
  methods: {
    toHome() {
      this.$router.push({
        path: '/index',
      })
    },
    toPrePage(num) {
      if (num == 'one') {
        this.$router.push({
          path: this.routeQuery.path1,
          query: {
            one: this.routeQuery.one,
            two: this.routeQuery.two,
            three: this.routeQuery.three,
            // path: '/clubInfo',
            path1: this.routeQuery.path1,
            path2: this.routeQuery.path2,
            keepalive: this.keepalive,
            // keepchild: -1,
            // articleId: item.id,
            id: this.routeQuery.id,
          },
        })
      } else if (num == 'two') {
        this.$router.push({
          path: this.routeQuery.path2,
          query: {
            one: this.routeQuery.one,
            two: this.routeQuery.two,
            three: '',
            // path: '/clubInfo',
            path1: this.routeQuery.path1,
            path2: this.routeQuery.path2,
            id: this.routeQuery.id,
            keepalive: this.keepalive,
            // keepchild: -1,
            // articleId: item.id,
          },
        })
      }
      //    else if (num == 'three') {

      //   }
    },
  },
  computed: {
    // breadList() {
    //   const list = this.$route.meta.breadList || []
    //   let str = ''
    //   if (
    //     this.$route.name == 'article' ||
    //     this.$route.name == 'teacher' ||
    //     this.$route.name == 'video'
    //   ) {
    //     str =
    //       list[0].name +
    //       ' > ' +
    //       this.routeQuery.one +
    //       ' > ' +
    //       this.routeQuery.two
    //     if (this.routeQuery.three != '') {
    //       str = str + ' > ' + this.routeQuery.three
    //     }
    //   } else {
    //     for (let i = 0; i < list.length; i++) {
    //       if (i == 0) {
    //         str = str + list[i].name
    //       } else {
    //         str = str + ' > ' + list[i].name
    //       }
    //     }
    //   }
    //   return str
    // },
  },
}
</script>
<style lang="scss" scoped>
.list {
  color: #2f2f2f;
  padding: 8px;
  .router-name {
    cursor: pointer;
    &:hover {
      color: #007a4d;
    }
  }
}
</style>
